// extracted by mini-css-extract-plugin
module.exports = {"JobBoardContainer":"JobBoardContainer_JobBoardContainer__25bii","FiltersLegendWrapper":"JobBoardContainer_FiltersLegendWrapper__DXevG"};